import {Utils} from './Utils'
import {StringUtils} from './StringUtils'
import Promise = require('bluebird');

export class FileUtils {
    private static _readFile(file: string, responseType: string = null, throwError: boolean = true): Promise<XMLHttpRequest> {
        responseType = Utils.valueOrDefault(responseType, null);
        throwError = Utils.valueOrDefault(throwError, true);

        return new Promise<XMLHttpRequest>((resolve: any, reject: any) => {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', file, true);
            if (!StringUtils.isNullOrEmpty(responseType)) {
                xhr.responseType = responseType;
            }

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200 || xhr.status == 0) {
                        return resolve(xhr);
                    } else {
                        if (throwError) {
                            return reject(new Error('Could not load file: ' + file));
                        } else {
                            resolve(null);
                        }
                    }
                }
            };
            xhr.send(null);
        });
    }

    public static readLocalFile(file: string, responseType: string = null, throwError: boolean = true): Promise<string> {
        return this._readFile(file, responseType, throwError)
            .then(xhr => {
                return xhr ? xhr.responseText : '';
            });
    }

    public static readLocalJsonFile<T>(file: string, throwError: boolean = true): Promise<T> {
        return FileUtils.readLocalFile(file, null, throwError)
            .then(fileContent => {
                if (fileContent) {
                    var res = Utils.parseJson(fileContent);
                    if (res.isValid) {
                        //return Promise.resolve(res.json as T);
                        return res.json as T;
                    }

                    if (throwError)
                    {
                        return Promise.reject(new Error(`File "${file}" content is not valid JSON object.`));
                    }
                }

                return null;
            });
    }

    public static readLocalXmlFile(file: string, throwError: boolean = true): Promise<XMLDocument> {
        return this._readFile(file, 'document', throwError)
            .then(xhr => {
                if (xhr)
                {
                    return xhr.responseXML as XMLDocument;
                }

                if (throwError)
                {
                    return Promise.reject(new Error(`File "${file}" could not be loaded.`));
                }

                return null;
            });
    }

    public static jsonPost<TResponse>(url: string, data?: Object): Promise<TResponse> {
        return new Promise<TResponse>((resolve: any, reject: any) => {
            $.ajax({
                method: "POST",
                dataType: 'json',
                url: url,
                data: data
            }).done((response: TResponse) => {
                resolve(response);
            }).fail(reject);
        });

    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Utils/FileUtils.ts
 **/